/* import __COLOCATED_TEMPLATE__ from './sh-slide-toggle.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';
import clsx from 'clsx';

const CLASS_NAME = 'SH-slide-toggle';
const LOCKED_CLASS_NAME = `${CLASS_NAME}--locked`;
const SLIDER_CLASS_NAME = `${CLASS_NAME}__slider`;
const SLIDER_TOGGLED_CLASS_NAME = `${SLIDER_CLASS_NAME}--toggled`;
const SLIDER_DISABLED_CLASS_NAME = `${SLIDER_CLASS_NAME}--disabled`;
const KNOB_CLASS_NAME = `${CLASS_NAME}__knob`;
const KNOB_TOGGLED_CLASS_NAME = `${KNOB_CLASS_NAME}--toggled`;
const KNOB_DISABLED_CLASS_NAME = `${KNOB_CLASS_NAME}--disabled`;
const TEXT_CLASS_NAME = `${CLASS_NAME}__text`;
const TEXT_TOGGLED_CLASS_NAME = `${TEXT_CLASS_NAME}--toggled`;
const TEXT_DISABLED_CLASS_NAME = `${TEXT_CLASS_NAME}--disabled`;
const KNOB_ICON_CLASS_NAME = `${KNOB_CLASS_NAME}__icon`;
const KNOB_ICON_TOGGLED_CLASS_NAME = `${KNOB_ICON_CLASS_NAME}--check`;
const KNOB_ICON_LOCKED_CLASS_NAME = `${KNOB_ICON_CLASS_NAME}--locked`;

class ShSlideToggle extends Component {
  @tracked sliderWidth = 0;

  get sliderClassNames() {
    return clsx(
      this.args.class,
      SLIDER_CLASS_NAME,
      this.args.isToggled && SLIDER_TOGGLED_CLASS_NAME,
      this.args.isDisabled && SLIDER_DISABLED_CLASS_NAME,
    );
  }

  get lockedClassNames() {
    return clsx(
      this.args.class,
      this.args.lockedStyles,
      LOCKED_CLASS_NAME,
    );
  }

  get knobClassNames() {
    return clsx(
      KNOB_CLASS_NAME,
      this.args.isToggled && KNOB_TOGGLED_CLASS_NAME,
      this.args.isDisabled && KNOB_DISABLED_CLASS_NAME,
    );
  }

  get textClassNames() {
    return clsx(
      TEXT_CLASS_NAME,
      this.args.isToggled && !this.args.isLocked && TEXT_TOGGLED_CLASS_NAME,
      this.args.isDisabled && TEXT_DISABLED_CLASS_NAME,
    );
  }

  get iconClassNames() {
    return clsx(
      'material-icons',
      KNOB_ICON_CLASS_NAME,
      this.args.isToggled && !this.args.isLocked && KNOB_ICON_TOGGLED_CLASS_NAME,
      this.args.isLocked && KNOB_ICON_LOCKED_CLASS_NAME,
    );
  }

  get sliderTrackWidth() {
    return htmlSafe(`--slider-track-width: ${this.sliderWidth}px;`);
  }
  
  @action
  sliderResize(size) {
    this.sliderWidth = size?.width ?? 0;
  }

  @action
  onClick() {
    if (!this.args.isDisabled) {
      this.args.onclick?.();
    }
  }
}

export default ShSlideToggle;
